<template>
  <BGModal :shown="dialogShown"
           max-width="1536px"
           :title="$t('booking_detail.title')">
    <template #content>
      <v-container fluid class="edit-booking" v-if="booking">
        <v-input hide-details="auto"
                 v-if="booking.hkiarace_account">
          <v-container fluid class="flex-column" v-if="booking.hkiarace_account.sasv">
            <legend class="v-label theme--light">{{ $t('admin_acc_gym_checkin.account_pic') }}</legend>
            <v-row>
              <v-col cols="6">
                <v-img thumbnail :src="getURL(booking.hkiarace_account.sasv.octopus_front)" contain height="400px"></v-img>
              </v-col>
              <v-col cols="6">
                <v-img thumbnail :src="getURL(booking.hkiarace_account.sasv.octopus_back)" contain height="400px"></v-img>
              </v-col>
            </v-row>

          </v-container>
        </v-input>
        <v-row>
          <v-col cols="6">
            <v-text-field readonly
                          :label="$t('admin_acc_booking.reference_number')"
                          hide-details
                          :value="booking.reference_number ? `BV${booking.reference_number.toString().padStart(10, '0')}` : $t('admin_acc_booking_add.maintenance_booking')"></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field readonly
                          :label="$t('admin_acc_booking.payment_reference_number')"
                          hide-details
                          :value="paymentReferenceNo || ''">
            </v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="booking.reference_number">
          <v-col cols="6">
            <v-text-field readonly
                          :label="$t('admin_user.serial_no')"
                          hide-details
                          :value="booking.hkiarace_account.serial_no">
              <template #append>
                <v-btn icon
                       @click="onMemberEdit">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field readonly
                          :label="$t('admin_acc_member.title')"
                          hide-details
                          :value="$t('name', {given_name: booking.hkiarace_account.given_name, surname: booking.hkiarace_account.surname})"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-text-field readonly
                          :label="$t('admin_acc_booking.reserved_at')"
                          hide-details
                          :value="$parseDate(booking.create_at)"></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field readonly
                          :label="$t('admin_acc_booking.status')"
                          hide-details
                          :value="$t(BOOKING_STATUS_LABEL[booking.status])"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-text-field readonly
                          :label="$t('admin_acc_booking.start_time')"
                          hide-details
                          :value="$parseDate(booking.start_time)"></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field readonly
                          :label="$t('admin_acc_booking.end_time')"
                          hide-details
                          :value="$parseDate(booking.end_time)"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field readonly
                          :label="$t('admin_acc_booking.facility')"
                          hide-details
                          :value="booking.item.name"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-textarea readonly
                        :label="$t('admin_acc_facility_type.additional_items')"
                        v-if="booking.additional_items.length > 0"
                        :rows="booking.additional_items.length"
                        no-resize
                        :value="booking.additional_items.map((i)=> `${i.type.name} x ${i.count}`).join('\n')"
                        hide-details></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field readonly
                          :label="$t('admin_acc_booking.checkin_time')"
                          hide-details
                          :value="booking.checkin_time ? $parseDate(booking.checkin_time) : 'N/A'"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field readonly
                          :label="$t('admin_acc_booking.checkout_time')"
                          hide-details
                          :value="booking.checkout_time ? $parseDate(booking.checkout_time) : 'N/A'"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field readonly
                          :label="$t('admin_acc_booking.second_contact_number')"
                          hide-details
                          :value="booking.second_contact_number"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-textarea outlined
                        :label="$t('admin_acc_booking.remarks')"
                        hide-details
                        v-model="booking.remarks"></v-textarea>
          </v-col>
        </v-row>


        <EditMemberModal :shown="editMemberModalShown"
                         :account-id="editingMemberId"
                         @cancel="editMemberModalShown = false"
                         @finish="onEditMemberModalFinish"></EditMemberModal>
      </v-container>
    </template>
    <template #footer>
      <v-row no-gutters v-if="booking">
        <v-btn @click="cancel"
               class="mr-3"
               depressed
               large>
          {{ $t('cancel') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary"
               class="ml-4"
               depressed
               large
               @click="saveRemarks">
          {{ $t('admin_acc_booking.save_remarks') }}
          <v-icon right>fas fa-check</v-icon>
        </v-btn>
        <v-btn color="primary"
               class="ml-4"
               depressed
               large
               v-if="(booking.status === BOOKING_STATUS.CONFIRMED || booking.status === BOOKING_STATUS.NO_SHOW) && !booking.checkin_time"
               @click="checkInBooking">
          {{ $t('admin_acc_booking.check_in') }}
          <v-icon right>fas fa-calendar-check</v-icon>
        </v-btn>
        <v-btn color="primary"
               class="ml-4"
               depressed
               large
               v-if="booking.status === BOOKING_STATUS.CONFIRMED && booking.item.type.additional_items && booking.item.type.additional_items.length > 0"
               @click="addAdditionalItems">
          {{ $t('admin_acc_booking.add_additional_item_title') }}
          <!--          <v-icon right>fas fa-hand-holding-usd</v-icon>-->
        </v-btn>
        <!--        <v-btn color="primary"-->
        <!--               class="ml-4"-->
        <!--               depressed-->
        <!--               large-->
        <!--               v-if="booking.status === BOOKING_STATUS.CONFIRMED && booking.checkin_time"-->
        <!--               @click="uncheckInBooking">-->
        <!--          {{ $t('admin_acc_booking.uncheck_in') }}-->
        <!--          <v-icon right>fas fa-calendar-times</v-icon>-->
        <!--        </v-btn>-->
        <v-btn color="primary"
               class="ml-4"
               depressed
               large
               v-if="(booking.status === BOOKING_STATUS.CONFIRMED || booking.status === BOOKING_STATUS.CREATED_BY_ADMIN) && !booking.checkin_time"
               @click="cancelBooking(false)">
          {{ $t('admin_acc_booking.cancel') }}
          <v-icon right>fas fa-trash</v-icon>
        </v-btn>
        <v-btn color="primary"
               class="ml-4"
               depressed
               large
               v-if="booking.status === BOOKING_STATUS.CONFIRMED"
               @click="cancelBooking(true)">
          {{ $t('admin_acc_booking.refund') }}
          <v-icon right>fas fa-hand-holding-usd</v-icon>
        </v-btn>
      </v-row>
    </template>
  </BGModal>
</template>
<script>
import BGModal from "@/components/BGModal";
import {ref, watch, computed} from "@vue/composition-api";
import {BOOKING_STATUS, BOOKING_STATUS_LABEL} from "@/constants";
import JwtScanner from "@/components/acc_booking/JwtScanner";
import PhotoPreviewInput from "@/components/PhotoPreviewInput";
import AdminAddAdditionalItemDialog from "@/components/acc_booking/AdminAddAdditionalItemDialog";

export default {
  name: 'EditBookingModal',
  components: {EditMemberModal: () => import('@/components/member/EditMemberModal'), PhotoPreviewInput, BGModal},
  props: {
    shown: Boolean,
    bookingId: String,
  },
  setup(props, {root, emit}) {
    const dialogShown = ref(props.shown);

    // Init
    watch(() => props.shown, (newValue, oldValue) => {
      if (newValue !== oldValue) {
        dialogShown.value = newValue;

        if (newValue) {
          getBooking();
        }
      }
    });
    const cancel = function () {
      emit('cancel');
    };

    //
    const editingMemberId = ref(null);
    const editMemberModalShown = ref(false);
    const onMemberEdit = function () {
      editingMemberId.value = booking.value.account.id;
      editMemberModalShown.value = true;
    };
    const onEditMemberModalFinish = function () {
      editMemberModalShown.value = false;
    }

    // Form
    const booking = ref(null);
    const paymentRecord = ref(null);
    const paymentReferenceNo = computed(() => {
      if (paymentRecord.value) {
        if (paymentRecord.value.payment_method === 'cyber_source') {
          return paymentRecord.value.cyber_source_payment_records[0].request_ref_no
        } else {
          return paymentRecord.value.union_pay_payment_records[0].order_id
        }
      }

      return null;
    })
    const accountPic = ref(null);
    const getBooking = function () {
      root.$callAPI('aafb/admin/booking/', {booking_id: props.bookingId}, (response) => {
        booking.value = response.body.booking;
        paymentRecord.value = response.body.payment_record;
        accountPic.value = response.body.booking.hkiarace_account.pic;
      });
    }

    const saveRemarks = function () {
      root.$callAPI('aafb/admin/booking/save_remarks/', {
        booking_id: props.bookingId, remarks: booking.value.remarks
      }, () => {
        root.$showAlertMessage(root.$t('admin_acc_booking.save_remarks_success_msg'));
        getBooking();
      })
    };
    const checkInBooking = async function () {
      // if (confirm(root.$t('admin_acc_booking.confirm_checkin_msg'))) {
      let cardId = await root.$dialog.showAndWait(JwtScanner, {
        title: root.$t('admin_acc_gym_checkin.scan_white_card'),
        targetKey: 'wht',
        manualInputKey: 'wht',
        manualInputLabel: root.$t('admin_acc_white_card.id'),
      });

      if (cardId === undefined) return;

      //
      let regex = /^A([0-9]*)$/;
      if (regex.test(cardId)) {
        cardId = parseInt(cardId.match(regex)[1])
      }

      root.$callAPI('aafb/admin/booking/checkin/', {
        booking_ids: [props.bookingId],
        account_pic: accountPic.value instanceof File ? await root.$convertFileToBase64(accountPic.value) : accountPic.value,
        white_card_ids: [cardId],
      }, (response) => {
        root.$showAlertMessage(root.$t('admin_acc_booking.checkin_success_msg'));
        getBooking();
        emit('refresh-dashboard');
      })
      // }
    }
    const uncheckInBooking = function () {
      if (confirm(root.$t('admin_acc_booking.confirm_uncheckin_msg'))) {
        root.$callAPI('aafb/admin/booking/uncheckin/', {booking_id: props.bookingId}, () => {
          root.$showAlertMessage(root.$t('admin_acc_booking.uncheckin_success_msg'));
          getBooking();
          emit('refresh-dashboard');
        })
      }
    }
    const cancelBooking = function (issueCoupon) {
      let msg = issueCoupon ? root.$t('admin_acc_booking.confirm_refund_msg') : root.$t('admin_acc_booking.confirm_cancel_msg');

      if (confirm(msg)) {
        root.$callAPI('aafb/admin/booking/cancel/', {
          booking_id: props.bookingId, issue_coupon: issueCoupon
        }, () => {
          root.$showAlertMessage(root.$t('admin_acc_booking.cancel_success_msg'));
          getBooking();
          emit('refresh-dashboard');
        });
      }
    };
    const addAdditionalItems = async function () {
      const additionalItems = await root.$dialog.showAndWait(
        AdminAddAdditionalItemDialog, {
          additionalItems: booking.value.item.type.additional_items,
          width: '800',
        });

      if (additionalItems === undefined) return;

      if (await root.$dialog.confirm({text: root.$t('admin_acc_booking.add_additional_item_confirm_msg'), showClose: false})) {
        root.$callAPI('aafb/admin/booking/add_additional_items/', {
          booking_id: props.bookingId, additional_items: additionalItems
        }, () => {
          root.$showAlertMessage(root.$t('admin_acc_booking.add_additional_item_success_msg'));
          getBooking();
          emit('refresh-dashboard');
        });
      }
    };

    const getURL = function (f) {
      if (f instanceof File) {
        return URL.createObjectURL(f);
      } else {
        return 'api/static/' + f;
      }
    };

    return {
      dialogShown,
      cancel,

      editingMemberId,
      editMemberModalShown,
      onMemberEdit,
      onEditMemberModalFinish,

      booking,
      paymentReferenceNo,
      accountPic,

      saveRemarks,
      checkInBooking,
      uncheckInBooking,
      cancelBooking,
      addAdditionalItems,

      getURL,

      BOOKING_STATUS,
      BOOKING_STATUS_LABEL,
    }
  }
}
</script>
